import { h, render, Component } from 'preact';

const showOrHide = (WrappedComponent) => class ToggleableComponent extends Component {
	render({ show, ...restProps }){
		return show ? <WrappedComponent {...restProps} /> : null;
	}
};


export default showOrHide;


// WEBPACK FOOTER //
// ../q-components/components/hoc/showOrHide.js